import { ReactNode } from 'react';
import { cx } from 'common/utils/cx';
import { getCurrencySymbol } from 'common/services/currency';
import { Input, InputNumber } from 'antd';
import { InputProps, SearchProps } from 'antd/lib/input';
import { InputNumberProps } from 'antd/lib/input-number';

import { Control } from '../Control';

interface PropsStringInput extends InputProps {
  label?: ReactNode;
  error?: ReactNode;
}

function EnhancedInput({ type, label, error, addonAfter, ...bag }: PropsStringInput) {
  return (
    <Control label={label} error={error}>
      <Input
        type={type}
        {...(addonAfter ? { addonBefore: addonAfter } : {})}
        className={cx({
          'ant-input-warning': error,
        })}
        {...bag}
      />
    </Control>
  );
}

EnhancedInput.Password = ({ type, label, error, addonAfter, ...bag }: PropsStringInput) => (
  <Control label={label} error={error}>
    <Input.Password
      type={type}
      {...(addonAfter ? { addonBefore: addonAfter } : {})}
      className={cx({
        'ant-input-warning': error,
      })}
      {...bag}
    />
  </Control>
);

interface PropsStringInputSearch extends SearchProps {
  label?: ReactNode;
  error?: ReactNode;
}

EnhancedInput.Search = ({ type, label, error, ...bag }: PropsStringInputSearch) => (
  <Control label={label} error={error}>
    <Input.Search
      type={type}
      className={cx({
        'ant-input-warning': error,
      })}
      {...bag}
    />
  </Control>
);

interface PropsNumberInput extends InputNumberProps {
  label?: ReactNode;
  error?: ReactNode;
  isCurrency?: boolean;
}

EnhancedInput.Number = ({ type, label, isCurrency, error, ...bag }: PropsNumberInput) => (
  <Control label={label} error={error}>
    <InputNumber
      type={type}
      className={cx({
        'ant-input-warning': error,
      })}
      formatter={isCurrency ? (value) => `${value} ${getCurrencySymbol()}` : undefined}
      parser={
        isCurrency
          ? (value) => {
              if (value && typeof value === 'string') {
                const splitValue = value.split(' ');
                if (splitValue.length > 1) {
                  return splitValue[0];
                }
                return '';
              }
              return value ? value.toString() : '';
            }
          : undefined
      }
      {...bag}
    />
  </Control>
);

export default EnhancedInput;
